//@libs
import PropTypes from "prop-types";
//@mui-material
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
//import UploadFileIcon from '@mui/icons-material/UploadFile';
//@components
import IconButton from "./";

const UploadIconButton = ({
  title = "Asignar",
  icon = null,
  ...props
}) => {
  return (
    <IconButton
      sx={{
        "&:hover": {
          color: "#FF0000",
          transform: "scale(1.1)",
        },
      }}
      title={title}
      icon={icon || <CloudUploadIcon />}
      {...props}
    />
  );
};

UploadIconButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
};

export default UploadIconButton;
